
import Vue from 'vue'

export default Vue.extend({
  name: 'App',
  created() {
    document.title = 'findoo Administration'
  }
})
